import { Injectable } from '@angular/core';

import { IInspection, IInspectionResponse } from '../../inspection/insp.interfaces';

import { APIURLConstantsService } from '../../services/api-url-service/apiurlconstants.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class InspService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  public getList(limit = 10, skip = 0, filters = {}, conds = {}, ordering = {}, exportar = false): Observable<IInspectionResponse> {
    let params = new HttpParams();
    params = params.append('limit', limit.toString());
    params = params.append('skip', skip.toString());
    
    Object.keys(filters)
      .filter(filter => (filters[filter] === 0 || filters[filter]))
      .forEach(filter => params = params.append(filter, filters[filter].toString()));

    Object.keys(conds)
      .filter(cond => (conds[cond] === 0 || conds[cond]))
      .forEach(cond => params = params.append(cond, conds[cond].toString()));

    Object.keys(ordering).filter(field => (ordering[field] === 0 || ordering[field]))
    .forEach(field => params = params.append((ordering[field] === 'ASC' ? 'orderAsc' : 'orderDesc'), field));

    params = params.append('export', exportar.toString());

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }
    
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + "inspections", this.options)
      .pipe(map(response => response || []));
  }
  
  public getAutocomplete(id: string): Observable<Array<{value: string, text: string}>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'autocomplete/' + id)
    .pipe(map(response => {return response || [];}));
  }

  public create(data): Observable<any> {
    return this.authHttp.post(APIURLConstantsService._API_BASE_URL + 'inspections', data)
      .pipe(map(response => response || {}));
  }

  public update(idInspection, data): Observable<any> {
    return this.authHttp.put(APIURLConstantsService._API_BASE_URL + 'inspections/'+idInspection, data)
      .pipe(map(response => response || {}));
  }

  public delete(idInspection): Observable<any> {
    return this.authHttp.delete(APIURLConstantsService._API_BASE_URL + 'inspections/'+idInspection)
      .pipe(map(response => response || {}));
  }

  constructor(private authHttp: HttpClient) {}

}
